export enum OperationPerformanceDNStatus {
  All = 'ALL',
  WithDN = 'WITH_DN',
  WithoutDN = 'WITHOUT_DN'
}
